import { type IOrganization } from "@/stores/user-store";
import { SubmissionsTable } from "../../Admin/SubmissionsTable/SubmissionsTable";

interface SubmissionsTabProps {
	browserLocationId?: string;
	organization: IOrganization;
}

const SubmissionsTab = (props: SubmissionsTabProps) => {
	const { browserLocationId, organization } = props;
	return (
		<SubmissionsTable
			organization={organization}
			browserLocationId={browserLocationId || ""}
		/>
	);
};
export { SubmissionsTab };
